export enum RecipientStatus {
  Pending = 'pending',
  Queued = 'queued',
  Completed = 'completed',
  Sent = 'sent',
  Failed = 'failed',
}
